import React from 'react';
import { defaultFavouritePositionList } from '../../../../../const';
import { ActionType, ChannelTypeInternal, GateModeInternal, UserAction } from '../../../../../data-access/gql-types/graphql';
import { ChannelActionDetails, FavouritePositions } from '../../../types';
import { ChannelGateType } from '../../../types/channel/gate';
import AdvancedActionSwitch from '../advanced-action-switch';
import CoverAction from '../cover';
import GateAction from '../gate';
import LightAction from '../light';
import SwitchAction from '../switch';

type ActionControlProps = {
  userAction: UserAction;
  channels: ChannelActionDetails[];
};

const ActionControl: React.FC<ActionControlProps> = ({ userAction, channels }) => {
  if (userAction.action.actionType === ActionType.Advanced) {
    return <AdvancedActionSwitch action={userAction} />;
  }

  switch (userAction.action.channelType) {
    case ChannelTypeInternal.Blind:
      return (
        <CoverAction
          action={userAction.action}
          channels={channels}
          favouritePositions={
            (userAction.favouritePositions?.length
              ? userAction.favouritePositions
              : defaultFavouritePositionList) as FavouritePositions | null
          }
        />
      );
    case ChannelTypeInternal.Gate:
      return (
        <GateAction
          channels={channels.filter((x) => (x.data as ChannelGateType).gateMode === GateModeInternal.RollUp)}
        />
      );
    case ChannelTypeInternal.Light:
      return <LightAction channels={channels} />;
    case ChannelTypeInternal.Switch:
      return <SwitchAction channels={channels} />;
    default:
      return null;
  }
};

export default ActionControl;
